var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelUnknownSts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7 11.1L5.2 8.6L6.3 7.5L7.7 8.9L10.7 5.9L11.8 7L7.7 11.1ZM8 1.5C7.7 1.5 7.3 1.5 7 1.6V3.1C7.3 3 7.7 3 8 3C11 3 13.5 5.5 13.5 8.5C13.5 11.5 11 14 8 14C5 14 2.5 11.5 2.5 8.5C2.5 7 3.1 5.7 4 4.7V6.5H5V3.5V2.5H4H1V3.5H3.1C1.8 4.8 1 6.5 1 8.5C1 12.4 4.1 15.5 8 15.5C11.9 15.5 15 12.4 15 8.5C15 4.6 11.9 1.5 8 1.5Z",
    fill: "#BABABA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelUnknownSts);
export default __webpack_public_path__ + "static/media/rel_unknown_sts.9159e4066b2bc1ae8ff52334b0b5bb62.svg";
export { ForwardRef as ReactComponent };